import { useState } from "react";
import type { GridSelectionModel } from "@mui/x-data-grid";

export const useOpenBankingResourceSelectionModel = () => useState<GridSelectionModel>([]);

export default useOpenBankingResourceSelectionModel;
